/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-param-reassign, import/extensions, import/no-unresolved */

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { makeRemoteDuplicateDiscount } from 'src/main/usecases/duplicate-discount/duplicate-discount'

export interface DuplicateDiscountStateInterface {
  data: any,
  loading: boolean,
  loaded: boolean,
  size?: number,
  page?: number,
  totalPages?: number,
  totalElements?: number,
  query?: string,
}

// Define the initial state using that type
const initialState: DuplicateDiscountStateInterface = {
  data: [],
  loading: true,
  loaded: false,
}

export interface DuplicateDiscountParamsProps {
  query?: string,
  size?: number,
  page?: number,
}

export interface DuplicateDiscountParamsInterface {
  id?: string,
  divisao?: string|null,
  size?: number,
  page?: number
}

export const fetchDuplicateDiscount = createAsyncThunk(
  'duplicate-discount/index',
  async (params: DuplicateDiscountParamsProps, thunkAPI) => {
    thunkAPI.dispatch(duplicateLoading())

    const response = makeRemoteDuplicateDiscount().index(params)

    thunkAPI.dispatch(duplicateReceived())
    thunkAPI.dispatch(duplicateLoaded())
    return response
  },
)

const slice = createSlice({
  name: 'duplicate-discount',
  initialState,
  reducers: {
    duplicateLoaded(state) {
      state.loaded = true
    },
    duplicateLoading(state) {
      state.loading = true
    },
    duplicateReceived(state) {
      if (state.loading) {
        state.loading = false
      }
    },

  },

  extraReducers: (builder) => {
    builder.addCase(fetchDuplicateDiscount.fulfilled, (state, action) => {
      state.data = action.payload.content
      state.size = action.payload.size
      state.page = action.payload.number
      state.totalPages = action.payload.totalPages
      state.totalElements = action.payload.totalElements
    })
  },
})

export const {
  duplicateLoaded,
  duplicateLoading,
  duplicateReceived,
} = slice.actions

export default slice.reducer
